import Image from "next/image";
import comingSoon from "../../../public/images/WCHComingSoon.jpg";

/** The site's own "coming soon" picture (400 by 300), also used for link previews of listings without a photo. */
export const COMING_SOON_SRC = "/images/WCHComingSoon.jpg";

/**
 * "Photo coming soon": our own image shown whole (`object-contain`, never cropped) in the nearest
 * relatively positioned parent, in place of a listing photo that is missing or fails to load. It is
 * not a listing photo: it is never counted as one, nothing is laid over it, its alt text says what
 * it is, and the brokerage and REALTOR.ca logo stay below the photo as for any listing. The real
 * photo replaces it on the first page load after the feed has one.
 */
export function ComingSoonPhoto({sizes, priority}: { sizes: string; priority?: boolean }) {
    return <Image src={comingSoon} alt="Photo coming soon" fill sizes={sizes} priority={priority} className="rounded object-contain"/>;
}
